import React from 'react';
import PropTypes from 'prop-types';

const RentalInformationHOC = (C) => {
  const RentalInfo = ({order, rental}) => (
    <C order={order} rental={rental} services={order.variableCosts} />
  );

  RentalInfo.PropTypes = {
    order:PropTypes.shape({
      variableCosts:PropTypes.array,
    }).isRequired,
    rental:PropTypes.shape({
      location:PropTypes.string.isRequired,
      propertyId:PropTypes.string.isRequired,
      imageUrl:PropTypes.string.isRequired,
    }).isRequired,
  };

  return RentalInfo;
};

export default RentalInformationHOC;
